import React from 'react';
import { Modal, Form, Input, DatePicker, Select, message } from 'antd';
import { useCreatePortalProjectMutation, useGetAccessibleClientsQuery } from '../../../redux/api/compassPortal';

const CreateProjectModal = ({ open, onClose }) => {
    const [form] = Form.useForm();
    const [createProject, { isLoading }] = useCreatePortalProjectMutation();
    const { data: clients } = useGetAccessibleClientsQuery();

    const clientOptions = (clients || []).map((name) => ({
        label: name,
        value: name,
    }));

    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            await createProject({
                client_name: values.client_name,
                project_name: values.project_name,
                kickoff_date: values.kickoff_date.format('YYYY-MM-DD'),
                delivery_date: values.delivery_date.format('YYYY-MM-DD'),
            }).unwrap();
            form.resetFields();
            onClose();
        } catch {
            // validation or API error
        }
    };

    return (
        <Modal
            title="Create Project"
            open={open}
            onOk={handleOk}
            onCancel={onClose}
            confirmLoading={isLoading}
            okText="Create"
            destroyOnClose
        >
            <Form form={form} layout="vertical" preserve={false}>
                <Form.Item
                    name="client_name"
                    label="Client"
                    rules={[{ required: true, message: 'Please select a client' }]}
                >
                    <Select
                        showSearch
                        placeholder="Select a client"
                        options={clientOptions}
                        filterOption={(input, option) =>
                            option.label.toLowerCase().includes(input.toLowerCase())
                        }
                    />
                </Form.Item>
                <Form.Item
                    name="project_name"
                    label="Project Name"
                    rules={[{ required: true, message: 'Please enter a project name' }]}
                >
                    <Input placeholder="e.g. Q2 2026 Compass Analysis" />
                </Form.Item>
                <Form.Item
                    name="kickoff_date"
                    label="Kick-off Date"
                    rules={[{ required: true, message: 'Please select a kick-off date' }]}
                >
                    <DatePicker style={{ width: '100%' }} />
                </Form.Item>
                <Form.Item
                    name="delivery_date"
                    label="Delivery Date"
                    rules={[{ required: true, message: 'Please select a delivery date' }]}
                >
                    <DatePicker style={{ width: '100%' }} />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default CreateProjectModal;
